import {Diagram, DiagramEvent, Set, Part} from 'gojs';

import {APPLICATION_GRAPH_POSITION_STORAGE_KEY} from 'src/constants';

import {Position} from './types';


export const makeClearDiagramHighlightsFn = (diagram: Diagram) => (_e: DiagramEvent) => {
  diagram.startTransaction('highlight');
  diagram.clearHighlighteds();
  diagram.commitTransaction('highlight');
};

export const makeOnPartDropHandler = (diagram: Diagram) => ({subject}: DiagramEvent) => {
  // Force 'correct' types since gojs types subject as `any`. see:
  // https://gojs.net/latest/api/symbols/DiagramEvent.html
  //
  // > "SelectionMoved", the user has moved selected Parts by DraggingTool;
  // > the DiagramEvent.subject is a Set of the moved Parts,
  const parts = subject as Set<Part>;

  let positions: Record<string, Position>;

  try {
    positions = JSON.parse(localStorage.getItem(APPLICATION_GRAPH_POSITION_STORAGE_KEY) || '{}');
  } catch (e) {
    positions = {};
  }


  parts.each((val) => {
    const {data: {id}, location: {x, y}} = val;
    positions[id] = {x, y};
  });

  localStorage.setItem(APPLICATION_GRAPH_POSITION_STORAGE_KEY, JSON.stringify(positions));
};
